<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：社員使用状況の確認画面(STDSDC01C10)                                                               _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->

<template>
  <BaseModal :show="isShow">
    <div class="popup" style="width: 760px">
      <div class="popup-head">社員使用状況の確認</div>
      <div class="popup-body blue" style="font-weight: normal">
        <p class="alignleft">各契約における社員使用状況は以下の通りです。</p>
        <br />
        <div class="frm-row">
          <span class="data-label w-160px" style="padding-left: 20px"
            >年末調整オプション</span
          >
          <div class="progress" style="width: 400px; height: 20px">
            <div
              :class="progressBarColor"
              :style="{ width: `${percentage}%` }"
              style="height: 20px"
            ></div>
          </div>
          <span class="frm-label">{{ dataSpace }}</span>
        </div>
        <br />
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button class="frm-btn strong large" @click="handleCancel">
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { defineEmits, defineProps, computed } from "vue";
import _ from "lodash";
import BaseModal from "@/components/Base/BaseModal.vue";

const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
    default: false,
  },
  usageStatusUsed: {
    type: Number,
    default: 0,
  },
  usageStatusTotal: {
    type: Number,
    default: 0,
  },
});

// **********************************************
//  プログレス データ使用状況
// **********************************************
const percentage = computed(() => {
  let percent = _.divide(props.usageStatusUsed, props.usageStatusTotal) * 100;
  if (!props.usageStatusTotal || props.usageStatusTotal == 0) {
    percent = 0;
  }
  if (percent > 100) {
    percent = 100;
  }
  return percent;
});
const progressBarColor = computed(() => {
  if (props.usageStatusTotal === 0 || isNaN(props.usageStatusTotal)) {
    return "generally";
  } else {
    let color = _.divide(props.usageStatusUsed, props.usageStatusTotal);
    // 通常時
    if (color >= 0 && color <= 0.8) {
      return "generally";
      // 80%超え
    } else if (color > 0.8 && color <= 0.9) {
      return "warn";
      // 90%超え
    } else if (color > 0.9) {
      return "full";
    } else {
      return "";
    }
  }
});
// **********************************************
//  データ使用状況
// **********************************************
const dataSpace = computed(() => {
  return usageBar(props.usageStatusUsed, props.usageStatusTotal);
});

// **********************************************
// ステータスバー
// **********************************************
const usageBar = (used, total) => {
  let result = `${used}/${total}人`;
  return result;
};

const emit = defineEmits(["cancel"]);

const handleCancel = () => {
  emit("cancel");
};
//#endregion
</script>
